import { render, staticRenderFns } from "./dashboard.pug?vue&type=template&id=65f38d54&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=65f38d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f38d54",
  null
  
)

export default component.exports